import script from "./FeedbackStats.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackStats.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackStats.vue?vue&type=style&index=0&id=2a5471d0&lang=css"

const __exports__ = script;

export default __exports__